<template>
  <v-dialog width="1200" persistent scrollable v-model="dialog">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Cập nhật điểm danh
        <v-spacer />
        <v-btn icon dark @click="closeDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <PopupUpdateTable :items="items" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="closeDialog">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="onSave">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { padStart } from 'lodash'
import PopupUpdateTable from './PopupUpdateTable.vue'
export default {
  components: { PopupUpdateTable },
  data: () => ({ dialog: false, items: [], isAuto: false }),
  computed: {
    ...mapGetters({
      srcItems: 'boardingClassSessionAttendance/items',
      absents: 'boardingClassSessionAttendance/absents',
    }),
  },
  methods: {
    ...mapActions({
      updateBySession: 'boardingClassSessionAttendance/updateBySession',
      refreshSessionAttendance: 'boardingClassSessionAttendance/fetchItems',
      refreshSession: 'boardingClassSession/fetchOne',
    }),
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    openDialog(isAuto = false) {
      this.items = this.srcItems.map(i => ({ ...i, status: i.status === 'none' ? 'attendance' : i.status }))
      const autoItemCount = padStart(this.srcItems.filter(i => i.status === 'none').length, 2, '0')
      this.isAuto = isAuto
      this.dialog = true
      setTimeout(() => {
        if (autoItemCount !== '00') {
          this.$dialog.confirm({
            title: 'Chú ý',
            text: `Hệ thống để trạng thái mặc định <strong>"Có mặt"</strong> cho ${autoItemCount} học sinh trong lớp. Vui lòng kiểm tra, điều chỉnh theo thực tế, sau đó ấn nút <strong>"Xác nhận"</strong> bên dưới.`,
            okText: 'Đồng ý',
            hideCancel: true,
          })
        }
      }, 500)
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    async onSave() {
      try {
        const sessionId = this.$route.params.id
        await this.updateBySession({ id: sessionId, absents: this.absents })
        await Promise.all([
          this.refreshSessionAttendance({ _sort: 'nameToNumber:ASC', boardingClassSession: sessionId }),
          this.refreshSession(sessionId),
        ])
        this.$alert.success('Cập nhật điểm danh thành công')
        this.closeDialog()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>